import { Collapse } from "bootstrap";

var accordion = (function () {
  /* ********** Privata variabler  ********************   */
  let accordionIndex = 0;
  let accordionWrapperIndex = 0;
  /* ********** Privata funktioner     */
  function buildAccordion(content) {
    content.querySelectorAll("p.foldable").forEach(function (elem) {
      var headerId = "foldableAccHead_" + accordionIndex;
      var contentId = "foldableAccContent_" + accordionIndex;
      accordionIndex++;

      var content = nextUntil(elem, "h2, h3, p.foldable, .foldableEnd");

      var itemWrapper = document.createElement("div");
      itemWrapper.className = "accordion-item";

      var headerWrapper = createWrapper(
        "div",
        "accordion-header",
        "id",
        headerId
      );

      var buttonWrapper = createWrapper(
        "button",
        "accordion-button collapsed js-accordion",
        "type",
        "button"
      );

      var textWrapper = document.createElement("span");
      textWrapper.className = "accordion-button-text";

      if (elem.hasAttribute("data-keep-html")) {
        textWrapper.innerHTML = elem.innerHTML;
      } 
      else 
      {
        textWrapper.textContent = elem.textContent;
      }
      

      buttonWrapper.setAttribute("data-bs-toggle", "collapse");
      buttonWrapper.setAttribute("data-bs-target", "#" + contentId);
      buttonWrapper.setAttribute("aria-expanded", "false");
      buttonWrapper.setAttribute("aria-controls", contentId);

      buttonWrapper.appendChild(textWrapper);
      headerWrapper.appendChild(buttonWrapper);
      itemWrapper.appendChild(headerWrapper);

      var contentWrapper = createWrapper(
        "div",
        "accordion-collapse collapse foldable",
        "id",
        contentId
      );
      contentWrapper.setAttribute("aria-labelledby", headerId);

      var bodyWrapper = document.createElement("div");
      bodyWrapper.className = "accordion-body";

      content.forEach(function (elem) {
        bodyWrapper.appendChild(elem);
      });

      contentWrapper.appendChild(bodyWrapper);
      itemWrapper.appendChild(contentWrapper);

      elem.parentElement.replaceChild(itemWrapper, elem);
    });

    content.querySelectorAll("div.accordion-item").forEach(function (elem) {
      if (!elem.parentElement.classList.contains("accordion")) {
        var accordionId = "foldableAcc_" + accordionWrapperIndex;
        accordionWrapperIndex++;
        var accordionWrapper = createWrapper(
          "div",
          "accordion accordion-brodtext",
          "id",
          accordionId
        );
        var newItem = document.createElement("div");
        newItem.className = "accordion-item";
        newItem.innerHTML = elem.innerHTML;
        accordionWrapper.appendChild(newItem);
        var content = nextUntil(elem, "h2, h3, p.foldable, .foldableEnd");
        content.forEach(function (elem) {
          accordionWrapper.appendChild(elem);
        });

        accordionWrapper
          .querySelectorAll("div.accordion-collapse.collapse.foldable")
          .forEach(function (elem) {
            elem.setAttribute("data-bs-parent", "#" + accordionId);
          });

        elem.parentElement.replaceChild(accordionWrapper, elem);
      }
    });

    var collapseElementList = [].slice.call(
      document.querySelectorAll(".collapse.foldable")
    );

    var collapseList = collapseElementList.map(function (collapseEl) {
      return new Collapse(collapseEl, { toggle: false });
    });
  }

  function createWrapper(node, classes, attr, attrValue) {
    var wrapper = document.createElement(node);
    wrapper.className = classes;
    wrapper.setAttribute(attr, attrValue);
    return wrapper;
  }

  function nextUntil(elem, selector) {
    var siblings = [];
    elem = elem.nextElementSibling;
    // As long as a sibling exists
    while (elem) {
      // If we've reached our match, bail
      if (elem.matches(selector)) break;
      // Otherwise, push it to the siblings array
      siblings.push(elem);

      // Get the next sibling element
      elem = elem.nextElementSibling;
    }
    return siblings;
  }

  /* ********** Exponerade funktioner     */
  function initAccordion() {
    accordionIndex = 0;
    accordionWrapperIndex = 0;
    buildAccordion(document.getElementById("mainBody"));
  }

  function updateAccordion(content) {
    if (content) {
      buildAccordion(content);
    }
  }

  /**
   * @returns {[[HTMLElement]]}
   */
  function getAllAccordionsContent() {
    var contentArrays = [];
    document
      .getElementById("mainBody")
      .querySelectorAll("p.foldable")
      .forEach(function (elem) {
        contentArrays = [
          ...contentArrays,
          nextUntil(elem, "h2, h3, p.foldable, .foldableEnd"),
        ];
      });
    return contentArrays;
  }

  /* ********** Returnera exponerat gränssnitt     */
  return {
    initAccordion: initAccordion,
    updateAccordion: updateAccordion,
    getAllAccordionsContent: getAllAccordionsContent,
  };
})();

export default accordion;
